export enum TabEnum {
  None = '',
  Users = 'users',
  Cooperation = 'cooperation',
  Analytics = 'analytics',
  Finance = 'finance'
}
